import { UserGroups } from 'pages/TeamMembers/const'
import { PaymentMethods } from 'types/beneficiaries'

export const CUSTOMER_WALLET_CURRENCY_PAYMENT_METHODS = {
  USD: [
    PaymentMethods.ACH,
    PaymentMethods.FEDNOW,
    PaymentMethods.FEDWIRE,
    PaymentMethods.SWIFT,
    PaymentMethods.RTP,
  ],
  EUR: [PaymentMethods.SEPA, PaymentMethods.SEPA_INSTANT, PaymentMethods.SWIFT],
  GBP: [PaymentMethods.FASTER_PAYMENT],
}

export const CUSTOMER_WALLET_CURRENCY_PAYMENT_METHODS_LABELS = {
  [PaymentMethods.ACH]: 'ACH',
  [PaymentMethods.FEDWIRE]: 'Fedwire',
  [PaymentMethods.SWIFT]: 'SWIFT',
  [PaymentMethods.SEPA]: 'SEPA',
  [PaymentMethods.SEPA_INSTANT]: 'SEPA Instant',
  [PaymentMethods.FASTER_PAYMENT]: 'Faster Payment',
  // Custom ones here
  SEPA_AND_SEPA_INSTANT: 'SEPA/SEPA Instant',
}

export const ROLES_REQUIRED_TO_ADD_CUSTOMER = [
  UserGroups['Workspace Owner'],
  UserGroups.Admin,
  UserGroups['Compliance-Plus'],
]
